<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14MARMs/image/1.png?1697494221302" alt="This image is the cover for the book The Divine School Bus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Divine School Bus
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Charis SIL";'>Celebrate the boundless spirit of children and embrace the profound role we play as adults in nurturing their growth and individuality. In this empowering book, we are reminded of the immense responsibility to lovingly guide and truly listen to our little ones. With a heartfelt intention, this captivating narrative aims to instill in children, from an early age, the unwavering belief that they have the power to embrace their authentic selves and deserve to be surrounded by safety and love. Discover the transformative journey that unfolds as we empower the youngest among us to flourish and thrive, embracing their unique spirit with unwavering confidence and joy.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maureen Petro
      </h2>
      
      <p class="authorDescription body article"><p>Maureen has been married to her husband, Paul, for more than 30 years. Together, they have three grown children, Luke, Shelly and Jake. Maureen is a Registered Nurse and a Child Sexual Abuse Survivor and Advocate. Maureen feels it is vitally important to empower children with the truth of who they are, at a very young age, for their health and happiness. Maureen believes we are all God&rsquo;s children who deserve to feel safe and loved while on this journey as a Spiritual Being having a human experience.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f2a4a52